import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Router from "./routes/Router";
import WithAuthentication from "./context/Authentication/WithAuthentication.tsx";
import WithWebInfo from "./context/WebInfo/WithWebInfo.tsx";

import { Toaster } from "react-hot-toast";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import { CardItemContextProvider } from "./context/CardItem/CardItemContext";
import { ManagementContextProvider } from "./context/AdminManagement/ManagementContext.jsx";
import { ProductContextProvider } from "context/ProductContext/ProductDataContext";

export default function App() {
  return (
    <div>
      <Tooltip style={{ zIndex: "10" }} id="my-tooltip" />
      <WithAuthentication>
        <WithWebInfo>
          <ProductContextProvider>
            <CardItemContextProvider>
              <ManagementContextProvider>
                <ScrollToTop />
                <Toaster />
                <Router />
              </ManagementContextProvider>
            </CardItemContextProvider>
          </ProductContextProvider>
        </WithWebInfo>
      </WithAuthentication>
    </div>
  );
}
const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();
  // Automatically scrolls to top whenever pathname changes
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   console.log("pathname app", pathname);
  // }, [pathname]);}
  useEffect(() => {
    // Disable the default scroll restoration
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};
